import React, { ReactComponentElement } from "react"
import { FieldSectionContainer, FieldSectionContainerTitle, FieldSectionContent } from "./styles"

export interface FieldSectionProps {
    title?: string

}

export const FieldSection: React.FunctionComponent<FieldSectionProps> = (props: React.PropsWithChildren<FieldSectionProps>) => {
    return (
        <FieldSectionContainer>

            {
                props.title &&
                <FieldSectionContainerTitle>
                    {
                        props.title
                    }
                </FieldSectionContainerTitle>
            }
            <FieldSectionContent>
                {
                    props.children
                }
            </FieldSectionContent>
        </FieldSectionContainer>
    )
}